import {Model, ModelMixin} from '../common/model.class';
import ProjectionInformation = Model.ProjectionInformation;

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
export class ContactInfo extends ModelMixin() implements Model<ContactInfo> {

    TYPE = ContactInfo;
    static projectionInformation = new ProjectionInformation('contactInfo');

    public phoneNumbers: {
        home?: string,
        work?: string,
        fax?: string,
        mobile?: string
    } = {};

    constructor(jsonData: {} = {}) {
        super();
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/profile/contact-info.model.ts